import React from "react";
import { InteractiveStatusCell } from "@/components/pages/settlement/components/table-cells/InteractiveStatusCell";
import { CheckinStatus, CheckoutStatus } from "@/types/reservation";
import { useReservationStatus } from "../../hooks/useReservationStatus";

interface ReservationStatusProps {
  checkinStatus?: CheckinStatus;
  checkoutStatus?: CheckoutStatus;
}

export const ReservationStatus: React.FC<ReservationStatusProps> = ({
  checkinStatus,
  checkoutStatus,
}) => {
  const { statusConfig } = useReservationStatus(checkinStatus, checkoutStatus);

  if (!statusConfig) return null;

  return (
    <InteractiveStatusCell
      statuses={statusConfig.statuses}
      currentStatus={statusConfig.currentStatus}
      onStatusChange={statusConfig.onStatusChange}
      className="min-w-fit ml-0 px-5 py-2.5 rounded-lg border-0 bg-violet"
      labelClassName="text-light-indigo font-medium"
    />
  );
};
